import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
import { AddDoorComponentonWall, commonFunctionForComponent } from "../common/common.helper";
import { const_var, params } from "../../redux/reducers/reducer";

export const makeComponentArrayForOtherBuilding = (state, iid) => {
    commonFunctionForComponent();
    const doorArr = const_var.CustomDoorArrForOtherBtype;
    doorArr[iid] = {
        Garage: [],
        Garage_Frameout: [],
        Windows: [],
        Windows_Frameout: [],
        Walk: [],
        Walk_Frameout: [],
        selectedIndex: []
    };

    doorArr[iid]["Garage_Frameout"]["standard_door"] = {
        "Roll-Up": {
            Size: [],
            Width: [],
            Height: []
        }
    };
    const newData = const_var.ComparisionDataArray[iid].pricing_data;
    let garageDoorSubCategory = "";
    let walkinDoorSubCategory = "";
    let walkinFrameDoorSubCategory = "";
    let windowsDoorSubCategory = "";
    let windowsFrameDoorSubCategory = "";
    const processElements = ({ data = [], elementType, iid, doorArr, state, const_var, setSubCategory }) => {
        data?.forEach((item) => {
            const key = item.alias_name;
            const elementData = item.sizes || [];
            if (setSubCategory && !setSubCategory) {
                setSubCategory.value = key;
            }
            doorArr[iid][elementType][key] = [];
            doorArr[iid][elementType][key] = elementData;
            doorArr[iid][elementType][key]["Size"] = [];
            elementData.forEach((entry) => {
                const isCustom = entry?.is_custom_size || false;
                const sizeName = isCustom ? "CustomGarageSize" : `${entry.fixed_sizes?.[0]?.width}x${entry.fixed_sizes?.[0]?.height}`;
                const sizeData = isCustom ? entry?.custom_sizes?.[0] : entry?.fixed_sizes?.[0];
                const cost = sizeData?.cost || 0;
                const sideCost = sizeData?.side_cost || 0;
                const verticalSideCost = sizeData?.vertical_side_cost || 0;
                doorArr[iid][elementType][key]["Size"][sizeName] = { ...entry, name: sizeName, cost: cost };
                if (const_var.loginSession !== false && isCustom) {
                    state.const_var.CustomDoorArrForOtherBtype[iid][elementType][key]["Size"]["Custom Size"] = "CustomGarageSize";
                }
                doorArr[iid][elementType][key]["Size"][sizeName].end_wall_price = cost;
                doorArr[iid][elementType][key]["Size"][sizeName].side_wall_price = sideCost + cost + verticalSideCost;
            });
        });
    };
    processElements({ data: newData?.garage_door_v3, elementType: "Garage", iid, doorArr, state, const_var, setSubCategory: { value: garageDoorSubCategory } });
    processElements({ data: newData?.walkin_door_v3, elementType: "Walk", iid, doorArr, state, const_var, setSubCategory: { value: walkinDoorSubCategory } });
    processElements({ data: newData?.walkin_door_frameout_v3, elementType: "Walk_Frameout", iid, doorArr, state, const_var, setSubCategory: { value: walkinFrameDoorSubCategory } });
    processElements({ data: newData?.window_v3, elementType: "Windows", iid, doorArr, state, const_var, setSubCategory: { value: windowsDoorSubCategory } });
    processElements({ data: newData?.window_frameout_v3, elementType: "Windows_Frameout", iid, doorArr, state, const_var, setSubCategory: { value: windowsFrameDoorSubCategory } });

    if (newData.garage_door_frameout.length > 0) {
        const rollUpSize = doorArr[iid]["Garage_Frameout"]["standard_door"]["Roll-Up"]["Size"];
        const rollUpWidth = doorArr[iid]["Garage_Frameout"]["standard_door"]["Roll-Up"]["Width"];
        const rollUpHeight = doorArr[iid]["Garage_Frameout"]["standard_door"]["Roll-Up"]["Height"];
        newData.garage_door_frameout.forEach((frameOut) => {
            const sizes = frameOut.sizes;
            sizes.forEach((size) => {
                const isCustom = size.is_custom_size;
                if (isCustom) {
                    const minWidth = Number(size?.custom_sizes[0]?.min_width) ?? 0;
                    const maxWidth = Number(size?.custom_sizes[0]?.max_width) ?? 0;
                    const cost = size?.custom_sizes[0]?.cost ?? 0;
                    const sideCost = size?.custom_sizes[0]?.side_cost ?? 0;
                    for (let i = minWidth; i <= maxWidth; i++) {
                        for (let j = 6; j <= state.params.p_h; j++) {
                            const sizeKey = `${j}x${i}`;
                            rollUpSize[sizeKey] = size;
                            rollUpSize[sizeKey].end_wall_price = cost;
                            rollUpSize[sizeKey].side_wall_price = sideCost;
                            rollUpWidth[j] = j;
                            rollUpHeight[i] = i;
                        }
                    }
                } else {
                    const sizeKey = size?.fixed_sizes[0].width + "x" + size?.fixed_sizes[0].height;
                    const cost = size?.cost;
                    const sideCost = size?.side_cost;
                    rollUpSize[sizeKey] = size;
                    rollUpSize[sizeKey].end_wall_price = cost;
                    rollUpSize[sizeKey].side_wall_price = sideCost;
                }
            });
        });
    }


    if (const_var.entry_points.length === 0) return;
    const getFirstNonCustom = (arr) => {
        if (arr[0]?.is_custom_size) {
            return arr.find((obj) => !obj.is_custom_size);
        }
        return arr[0];
    };

    // Helper: checks lean-to clearance overlap for a given entry point value
    const checkLeanOverlap = (value) => {
        if (
            cuComponent.wallnameBySec[value.component_wall_name] !== "center" ||
            !const_var.isManufacturerForLeantoClearance ||
            !(iid.split && iid.split("_")[0] === const_var.manufacturerForLeantoClearance) ||
            const_var.editAPIDataByResponse.data?.main_created_at < "2025-09-19"
        )
            return false;

        const px = value.entry_position.positionX;
        const hw = value.entry_dimension_width / 2;
        const dh = value.entry_dimension_height;
        const wn = value.component_wall_name;

        if (
            params.add_left_lean &&
            (wn === "c_b_l_w" || wn === "c_b_l_s_w") &&
            px + hw > params.lean_p_pos - params.lean_p_d / 2 &&
            px - hw < params.lean_p_pos + params.lean_p_d / 2 &&
            dh >= params.lean_p_h + (params.lean_p_w * Number(params.b_l_t_r_p)) / 12
        )
            return true;

        if (
            params.add_right_lean &&
            (wn === "c_b_r_w" || wn === "c_b_r_s_w") &&
            -px + hw > params.leanR_p_pos - params.leanR_p_d / 2 &&
            -px - hw < params.leanR_p_pos + params.leanR_p_d / 2 &&
            dh >= params.leanR_p_h + (params.leanR_p_w * Number(params.b_l_t_r_pR)) / 12
        )
            return true;

        if (
            params.add_front_lean &&
            wn === "c_b_f_w" &&
            px + hw > params.leanF_p_pos - params.leanF_p_d / 2 &&
            px - hw < params.leanF_p_pos + params.leanF_p_d / 2 &&
            dh >= params.leanF_p_h + (params.leanF_p_w * Number(params.b_l_t_r_pF)) / 12
        )
            return true;

        if (
            params.add_back_lean &&
            wn === "c_b_b_w" &&
            -px + hw > params.leanB_p_pos - params.leanB_p_d / 2 &&
            -px - hw < params.leanB_p_pos + params.leanB_p_d / 2 &&
            dh >= params.leanB_p_h + (params.leanB_p_w * Number(params.b_l_t_r_pB)) / 12
        )
            return true;

        return false;
    };

    const filterData = [];
    const_var.entry_points.map((value, key) => {
        if (value.parent_array_key === "Garage") {
            const garageByKey = doorArr[iid]["Garage"]; //[value.child_array_key]
            const targetArr = garageByKey?.[value.nested_array_key];
            const { child_array_key, nested_array_key, component_name } = value;
            // const category = 'standard'
            if (targetArr !== undefined) {
                const size = targetArr.Size;
                const match = Object.entries(size).filter(([key, item]) => item.name === value.entry_size.name)?.[0]?.[1] || {};
                doorArr[iid]["selectedIndex"][key] = { ...match, child_array_key, nested_array_key, component_name } ?? { ...getFirstNonCustom(targetArr.sizes), child_array_key, nested_array_key, component_name };
            } else {
                const standardGarage = doorArr[iid]["Garage"][garageDoorSubCategory]?.['Size'];
                if (standardGarage) {
                    const newGarageType = { ...Object.entries(standardGarage)?.[0]?.[1], child_array_key, nested_array_key, component_name };
                    doorArr[iid]["selectedIndex"][key] = newGarageType ?? {};
                }
            }
            if (checkLeanOverlap(value)) {
                doorArr[iid]["selectedIndex"][key] = doorArr[iid]["Garage"][garageDoorSubCategory]; //[category]
            }
        }
        // ── Garage Frameout ───────────────────────────────────────────────────
        if (value.parent_array_key === "Garage_Frameout" && !value.is_breezeway_frameout) {
            const overlapWith = checkLeanOverlap(value);
            const { child_array_key, nested_array_key, component_name } = value;
            // const category = 'standard';
            const targetArr = doorArr[iid]["Garage_Frameout"]["Roll-Up"]["Size"];
            if (targetArr !== undefined) {
                const match = Object.entries(targetArr).filter(([key, item]) => item.name === value.entry_size.name)?.[0]?.[1] || {};
                doorArr[iid]["selectedIndex"][key] = { ...match, child_array_key, nested_array_key, component_name } ?? { ...getFirstNonCustom(targetArr.sizes), child_array_key, nested_array_key, component_name };
            }
        }

        // ── Walk ──────────────────────────────────────────────────────────────
        if (value.parent_array_key === "Walk") {
            const walkByKey = doorArr[iid]["Walk"];
            const targetArr = walkByKey?.[value.nested_array_key];
            const { child_array_key, nested_array_key, component_name } = value;
            // const category = 'standard';
            if (targetArr !== undefined) {
                const size = targetArr.Size;
                const match = Object.entries(size).filter(([key, item]) => item.name === value.entry_size.name)?.[0]?.[1] || {};
                doorArr[iid]["selectedIndex"][key] = { ...match, child_array_key, nested_array_key, component_name } ?? getFirstNonCustom(targetArr.sizes);
            } else {
                const standardWalkin = doorArr[iid]["Walk"][walkinDoorSubCategory]?.['Size'];
                if (standardWalkin) {
                    const newDoorType = Object.entries(standardWalkin)?.[0]?.[1];
                    doorArr[iid]["selectedIndex"][key] = { ...newDoorType, child_array_key, nested_array_key, component_name } ?? {};
                }
            }
        }

        // ── Walk Frameout ─────────────────────────────────────────────────────
        if (value.parent_array_key === "Walk_Frameout") {
            const walkFByKey = doorArr[iid]["Walk_Frameout"];
            const targetArr = walkFByKey?.[value.nested_array_key];
            const { child_array_key, nested_array_key, component_name } = value;
            // const category = 'standard';
            if (targetArr !== undefined) {
                const size = targetArr.Size;
                const match = Object.entries(size).filter(([key, item]) => item.name === value.entry_size.name)?.[0]?.[1] || {};
                doorArr[iid]["selectedIndex"][key] = { ...match, child_array_key, nested_array_key, component_name } ?? getFirstNonCustom(targetArr);
            } else {
                const standerdWalkInFrame = doorArr[iid]["Walk_Frameout"][walkinFrameDoorSubCategory]?.['Size'];
                if (standerdWalkInFrame) {
                    const newDoorType = Object.entries(standerdWalkInFrame)?.[0]?.[1];
                    doorArr[iid]["selectedIndex"][key] = { ...newDoorType, child_array_key, nested_array_key, component_name } ?? {};
                }
            }
        }

        // ── Windows ───────────────────────────────────────────────────────────
        if (value.parent_array_key === "Windows") {
            const winByKey = doorArr[iid]["Windows"];
            const targetArr = winByKey?.[value.nested_array_key];
            const { child_array_key, nested_array_key, component_name } = value;
            // const category = 'standard';
            if (targetArr !== undefined) {
                const size = targetArr.Size;
                const match = Object.entries(size).filter(([key, item]) => item.name === value.entry_size.name)?.[0]?.[1] || {};
                doorArr[iid]["selectedIndex"][key] = { ...match, child_array_key, nested_array_key, component_name } ?? getFirstNonCustom(targetArr);
            } else {
                const standardWindow = doorArr[iid]["Windows"][windowsDoorSubCategory]?.['Size'];
                if (standardWindow) {
                    const newWindow = Object.entries(standardWindow)?.[0]?.[1];
                    doorArr[iid]["selectedIndex"][key] = { ...standardWindow, child_array_key, nested_array_key, component_name } ?? {};
                }
            }
        }

        // ── Windows Frameout ──────────────────────────────────────────────────
        if (value.parent_array_key === "Windows_Frameout") {
            const winFByKey = doorArr[iid]["Windows_Frameout"];
            const targetArr = winFByKey?.[value.nested_array_key];
            const { child_array_key, nested_array_key, component_name } = value;
            // const category = 'standard';
            if (targetArr !== undefined) {
                const size = targetArr.Size;
                const match = Object.entries(size).filter(([key, item]) => item.name === value.entry_size.name)?.[0]?.[1] || {};
                doorArr[iid]["selectedIndex"][key] = { ...match, child_array_key, nested_array_key, component_name } ?? getFirstNonCustom(targetArr);
            } else {
                const standardWindowFrame = doorArr[iid]["Windows"][windowsFrameDoorSubCategory]?.['Size'];
                if (standardWindowFrame) {
                    const newWindow = Object.entries(standardWindowFrame)?.[0]?.[1];
                    doorArr[iid]["selectedIndex"][key] = { ...standardWindowFrame, child_array_key, nested_array_key, component_name } ?? {};
                }
            }
        }

    });
};
export const makeComponentArray = (state, componentData) => {
    console.log(componentData, "DoorWindowPrice");
    state.const_var.door_w_arr["Width"] = "Select";
    state.const_var.door_h_arr["Height"] = "Select";
    state.const_var.CustomDoorArr["Garage"]["Size"].Size = "Select";

    state.const_var.walkFrameoutInitialValue = "";
    state.const_var.walkInitialValue = "";
    state.const_var.windowsFrameoutInitialValue = "";
    state.const_var.windowsInitialValue = "";
    state.const_var.customFrameoutInitialSize = "";
    state.const_var.garageInitialValue = "";
    const_var.newComponentArray["Garage"] = [];
    const_var.newComponentArray["Garage_Frameout"] = [];
    const_var.newComponentArray["Windows"] = [];
    const_var.newComponentArray["Windows_Frameout"] = [];
    const_var.newComponentArray["Walk"] = [];
    const_var.newComponentArray["Walk_Frameout"] = [];
    const_var.newComponentArray["Garage_Frameout"]["standard_door"] = [];
    const_var.newComponentArray["Garage_Frameout"]["standard_door"]["Roll-Up"] = [];
    const_var.newComponentArray["Garage_Frameout"]["standard_door"]["Roll-Up"]["Size"] = [];
    const_var.newComponentArray["Garage_Frameout"]["standard_door"]["Roll-Up"]["Width"] = [];
    const_var.newComponentArray["Garage_Frameout"]["standard_door"]["Roll-Up"]["Height"] = [];
    let isShowCustomSize = true;
    let isShowWindowCutomSize = true;
    let CustomSizeStatus = const_var.c_m_a[params.p_b_t].custom_size_status;
    let isCustomSize = "none";

    if (componentData && componentData.value) {
        if (componentData.value?.garage_doors) {
            const_var.newComponentArray["Garage"] = componentData.value.garage_doors.map((item) => {
                const sizes = item.sizes.filter((size) => !size.is_custom_size);
                const customSizes = item.sizes.filter((size) => size.is_custom_size);
                return {
                    type: item.door_type,
                    name: item.name,
                    alias_name: item.alias_name,
                    sizes,
                    customSizes
                };
            });
        }

        if (componentData.value?.walk_in_doors) {
            const_var.newComponentArray["Walk"] = componentData.value.walk_in_doors.map((item) => {
                const sizes = item.sizes.filter((size) => !size.is_custom_size);
                const customSizes = item.sizes.filter((size) => size.is_custom_size);
                return {
                    type: item.door_type,
                    name: item.name,
                    alias_name: item.alias_name,
                    sizes,
                    customSizes
                };
            });
        }

        if (componentData.value?.windows) {
            const_var.newComponentArray["Windows"] = componentData.value.windows.map((item) => {
                const sizes = item.sizes.filter((size) => !size.is_custom_size);
                const customSizes = item.sizes.filter((size) => size.is_custom_size);
                return {
                    type: item.window_type,
                    name: item.name,
                    alias_name: item.alias_name,
                    sizes,
                    customSizes
                };
            });
        }

        // commonFunctionForComponent();
    }
};
export const handleDefaultDoorWindow = ({ const_var, state, params, isEdit, DoorMainIndexName, AddDoorComponentonWall, isLandTshapeDoor }) => {
   let is_default_door=true
    if (
        const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch != undefined &&
        const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0 &&
        Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].wall).length > 1 &&
        const_var.defaultBuildingArr[state.defaultBuilding].wall.front != undefined
    ) {
        let DoorMainIndexName = "";
        let isLandTshapeDoor = false;
        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            const newArr = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter((data) => {
                let checkType = data.component == undefined ? data.type : data.type;
                return true;
            });
            const_var.defaultBuildingArr[state.defaultBuilding].default_doors = newArr;

            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.map(async (data, index) => {
                if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && (data.wall == "right" || data.wall == "c_b_r_w")) {
                    data.wall = "F_S_L_R_W";
                }
                if (isEdit === false && const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && data.wall === "F_S_L_R_W") {
                    data.wall = "c_b_r_w";
                }
                if (state.const_var.defaultBuildingImgName == "Utility_Buildings" && params.p_u_c == true) {
                    data.wall = data.wall == "front" ? "ufend" : data.wall;
                }

                let checkType = data.component == undefined ? data.type : data.component;

                if (checkType == "standard_door" || checkType == "garage_door") {
                    if (data.category == "Garage Door") {
                        //data.category = "Roll-Up"
                    }
                    DoorMainIndexName = "Garage";
                }

                if (checkType == "garage_door_frameout") {
                    if (const_var.defaultBuildingArr[state.defaultBuilding]?.image_name?.includes("L-shape-building")) isLandTshapeDoor = true;
                    DoorMainIndexName = "Garage_Frameout";
                }
                if (data.component.includes("walkin")) {
                    if (data.component == "walk_in_door" || data.component == "walkin") {
                        data.component = "walkin";
                    }
                    DoorMainIndexName = "Walk";
                }
                if (data.type == "walkin_frameout") {
                    DoorMainIndexName = "Walk_Frameout";
                }
                if (data.type.includes("window") && !data.type.includes("walkin") && !data.type.includes("window_frameout")) {
                    DoorMainIndexName = "Windows";
                }
                if (data.type == "window_frameout" || data.component == "window_frameout") {
                    DoorMainIndexName = "Windows_Frameout";
                }
                if (data != undefined) {
                    let dataMap = const_var.newComponentArray[DoorMainIndexName].find((item) => item.type == data.type);
                    AddDoorComponentonWall(
                        data.component,
                        data.type,
                        const_var.entry_wall_location_reverse[data.wall] != undefined ? const_var.entry_wall_location_reverse[data.wall] : data.wall,
                        data.size,
                        DoorMainIndexName,
                        data.type,
                        dataMap ? dataMap.alias_name : data.name,
                        undefined,
                        data?.position,
                        undefined,
                        undefined,
                        undefined,
                        isLandTshapeDoor,
                        is_default_door
                    );
                }
            });
        }
    } else {
        console.log(const_var.defaultBuildingArr[state.defaultBuilding], const_var.defaultBuildingArr, "const_var.showProcessLoaderchkEdit");
        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors != null && typeof const_var.defaultBuildingArr[state.defaultBuilding].default_doors == "string") {
            const_var.defaultBuildingArr[state.defaultBuilding].default_doors = JSON.parse(const_var.defaultBuildingArr[state.defaultBuilding].default_doors);
        }

        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            const_var.defaultBuildingArr[state.defaultBuilding].default_doors.map((data, index) => {
                let checkType = data.component == undefined ? data.type : data.component;
                if (checkType == "standard_door" || checkType == "garage_door") {
                    if (data.type == "garage_door") {
                        data.type = "standard_door";
                    }
                    if (data.component == undefined) {
                        data.component = checkType;
                        if (data.category == undefined) {
                            data.category = "Roll-Up";
                        }
                    }
                    if (const_var.newComponentArray["Garage"][data.type] == undefined) {
                        const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index, 1);
                    }
                    if (data.category != undefined && const_var.newComponentArray["Garage"][data.type][data.category] == undefined) {
                        const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index, 1);
                    }
                }
                if (data.type == "standard_walkin") {
                    if (const_var.newComponentArray["Walk"][data.type] == undefined) {
                        const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index, 1);
                    }
                    if (data.category != undefined && const_var.newComponentArray["Walk"][data.type][data.category] == undefined) {
                        const_var.defaultBuildingArr[state.defaultBuilding].default_doors.splice(index, 1);
                    }
                }
            });
        }
        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter((data) => data.wall == "left" || data.wall == "c_b_l_w");
            if (leftWallComponent.length > 0) {
                let mainPos = 0;
                let mainPosArray = [];
                for (let leftWallData of leftWallComponent) {
                    let h = (params.p_w / -2 - 0) * 1 - 1 * 1;
                    let j = (params.p_d / 2 + 0) * 1 + 1 * 1;
                    let newData = "";
                    let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                    // console.log({checkType});
                    if (checkType == "garage_door") {
                        var splitname = leftWallData.size.split("x");
                        if (mainPosArray[mainPos - 1] == undefined) {
                            newData = params.p_d / 2 - (splitname[0] / 2 + 1);
                        } else {
                            newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt(splitname[0]) + 1);
                        }
                        state.params.DoorPosOnEdit = { x: h, y: 0, z: newData };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = (Math.PI / -2) * 1;
                        state.params.doorType = "Garage";
                        if (leftWallData.component == undefined) {
                            AddDoorComponentonWall(leftWallData.type, "standard_door", const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, "Garage", "standard_door", "Roll-Up");
                        } else {
                            AddDoorComponentonWall(
                                leftWallData.component,
                                "standard_door",
                                const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Garage",
                                leftWallData.type,
                                leftWallData.category
                            );
                        }
                    } else {
                        var splitname = leftWallData.size.split("x");
                        if (mainPosArray[mainPos - 1] == undefined) {
                            newData = params.p_d / 2 - (splitname[0] / 12 / 2 + 1);
                        } else {
                            newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt(splitname[0] / 12) + parseInt(splitname[0] / 12));
                        }
                        state.params.DoorPosOnEdit = { x: h, y: 0, z: newData };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = (Math.PI / -2) * 1;
                        params.doorType = "Walk";

                        if (leftWallData.component == undefined) {
                            if (const_var.newComponentArray["Walk"]["standard_walkin"] != undefined) {
                                AddDoorComponentonWall(leftWallData.type, "standard_walkin", const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, "Walk", "standard_walkin", "Man Door");
                            }
                        } else {
                            AddDoorComponentonWall(
                                leftWallData.component == "walk_in_door" ? "walkin" : leftWallData.component,
                                leftWallData.type,
                                const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Walk",
                                leftWallData.type,
                                leftWallData.category
                            );
                        }
                    }
                    mainPos++;
                }
            }
        }
        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter((data) => data.wall == "right" || data.wall == "c_b_r_w");
            if (leftWallComponent.length > 0) {
                let mainPos = 0;
                let mainPosArray = [];
                for (let leftWallData of leftWallComponent) {
                    let h = (params.p_w / 2 + 0) * 1 + 1 * 1;
                    let newData = "";
                    let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                    if (checkType == "garage_door") {
                        var splitname = leftWallData.size.split("x");

                        if (mainPosArray[mainPos - 1] == undefined) {
                            // console.log(newData,"params.DoorPosOnEdit111")
                            newData = params.p_d / 2 - (splitname[0] / 2 + 1);
                        } else {
                            // console.log(newData,"params.DoorPosOnEdit2222",splitname,splitname[0],typeof splitname[0],Number(mainPosArray[mainPos-1]) - Number(splitname[0]+1))
                            newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt(splitname[0]) + 1);
                        }
                        state.params.DoorPosOnEdit = { x: h, y: 0, z: newData };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = (Math.PI / 2) * 1;
                        state.params.doorType = "Garage";
                        let newWallName = const_var.entry_wall_location_reverse[leftWallData.wall];
                        if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing")) {
                            newWallName = "c_b_r_w";
                        }
                        if (leftWallData.component == undefined) {
                            AddDoorComponentonWall(leftWallData.type, "standard_door", newWallName, leftWallData.size, "Garage", "standard_door", "Roll-Up");
                        } else {
                            AddDoorComponentonWall(leftWallData.component, "standard_door", newWallName, leftWallData.size, "Garage", leftWallData.type, leftWallData.category);
                        }
                    } else {
                        state.params.p_a_g_r_u_d = "Select";
                        var splitname = leftWallData.size.split("x");
                        if (mainPosArray[mainPos - 1] == undefined) {
                            newData = params.p_d / 2 - (splitname[0] / 12 / 2 + 1);
                        } else {
                            newData = Number(mainPosArray[mainPos - 1]) - Number(parseInt(splitname[0] / 12) + parseInt(splitname[0] / 12) + 2);
                        }
                        state.params.DoorPosOnEdit = { x: h, y: 0, z: newData };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = (Math.PI / 2) * 1;
                        params.doorType = "Walk";
                        params.p_d_c = splitname[0] + "X" + splitname[1];
                        if (leftWallData.component == undefined) {
                            if (const_var.newComponentArray["Walk"]["standard_walkin"] != undefined) {
                                AddDoorComponentonWall(leftWallData.type, "standard_walkin", const_var.entry_wall_location_reverse[leftWallData.wall], leftWallData.size, "Walk", "standard_walkin", "Man Door");
                            }
                        } else {
                            AddDoorComponentonWall(
                                leftWallData.component == "walk_in_door" ? "walkin" : leftWallData.component,
                                leftWallData.type,
                                const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Walk",
                                leftWallData.type,
                                leftWallData.category
                            );
                        }
                    }
                    mainPos++;
                }
            }
        }

        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter((data) => data.wall == "front" || data.wall == "c_b_f_w" || data.wall == "ufend");
            if (leftWallComponent.length > 0) {
                let mainPos = 0;
                let mainPosArray = [];
                for (let leftWallData of leftWallComponent) {
                    let h = (params.p_w / 2 + 0) * 1 + 1 * 1;
                    let newData = "";
                    let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                    if (checkType == "garage_door") {
                        var splitname = leftWallData.size.split("x");

                        if (mainPosArray[mainPos - 1] == undefined) {
                            newData = params.p_w / -2 + (splitname[0] / 2 + 1);
                            // console.log(newData,"params.DoorPosOnEdit111");
                        } else {
                            newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt(splitname[0]) + 2);
                            // console.log(newData,"params.DoorPosOnEdit2222",splitname,splitname[0],typeof splitname[0],Number(mainPosArray[mainPos-1]) - Number(splitname[0]+1));
                        }
                        if (leftWallComponent.length == 1) {
                            newData = 0;
                        }
                        let componentdimension = leftWallData.size.split("x");
                        const doorWidth = checkType == "garage_door" ? parseInt(componentdimension[0]) : parseInt(componentdimension[0]) / 12,
                            doorHeight = checkType == "garage_door" ? parseInt(componentdimension[1]) : parseInt(componentdimension[1]) / 12;

                        if (params.p_u_c != true) {
                            state.params.DoorPosOnEdit = { x: newData, y: doorHeight / 2, z: params.p_d / 2 - 0.09 };
                        } else {
                            state.params.DoorPosOnEdit = { x: newData, y: doorHeight / 2, z: -params.p_d / 2 + Number(params.p_u_t) - 0.09 };
                        }
                        mainPosArray[mainPos] = newData;
                        // console.log(state.params.DoorPosOnEdit,"newData")
                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = 0;
                        state.params.doorType = "Garage";
                        if (leftWallData.component == undefined) {
                            AddDoorComponentonWall(
                                leftWallData.type,
                                "standard_door",
                                params.p_u_c == true ? const_var.entry_wall_location_reverse["ufend"] : const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Garage",
                                "standard_door",
                                "Roll-Up",
                                "",
                                params.DoorPosOnEdit
                            );
                        } else {
                            AddDoorComponentonWall(
                                leftWallData.component,
                                leftWallData.type,
                                params.p_u_c == true ? const_var.entry_wall_location_reverse["ufend"] : const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Garage",
                                leftWallData.type,
                                leftWallData.category,
                                "",
                                params.DoorPosOnEdit
                            );
                        }
                        // console.log(state.params.DoorPosOnEdit,"newData")
                    } else {
                        state.params.p_a_g_r_u_d = "Select";
                        var splitname = leftWallData.size.split("x");
                        if (mainPosArray[mainPos - 1] == undefined) {
                            newData = params.p_d / -2 + (splitname[0] / 12 / 2 + 1);
                        } else {
                            newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt(splitname[0] / 12) + parseInt(splitname[0] / 12) + 2);
                        }
                        state.params.DoorPosOnEdit = { x: newData, y: 0, z: params.p_d / 2 };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = 0;
                        params.doorType = "Walk";
                        params.p_d_c = splitname[0] + "X" + splitname[1];
                        if (leftWallData.component == undefined) {
                            AddDoorComponentonWall(
                                leftWallData.type,
                                "standard_walkin",
                                const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Walk",
                                "standard_walkin",
                                "Man Door",
                                params.DoorPosOnEdit
                            );
                        } else {
                            AddDoorComponentonWall(
                                leftWallData.component,
                                leftWallData.type,
                                const_var.entry_wall_location_reverse[leftWallData.wall],
                                leftWallData.size,
                                "Walk",
                                leftWallData.type,
                                leftWallData.category,
                                params.DoorPosOnEdit
                            );
                        }
                    }
                    mainPos++;
                }
            }
        }
        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            let leftWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter((data) => data.wall == "back" || data.wall == "c_b_b_w");
            if (leftWallComponent.length > 0) {
                let mainPos = 0;
                let mainPosArray = [];
                for (let leftWallData of leftWallComponent) {
                    params.p_w_cc = "Select";
                    params.p_d_c = "Select";
                    params.p_a_g_r_u_d = "Select";
                    let h = (params.p_w / 2 + 0) * 1 + 1 * 1;
                    let newData = "";
                    let checkType = leftWallData.component == undefined ? leftWallData.type : leftWallData.component;
                    if (checkType == "garage_door") {
                        var splitname = leftWallData.size.split("x");

                        if (mainPosArray[mainPos - 1] == undefined) {
                            // console.log(newData,"params.DoorPosOnEdit111")
                            newData = params.p_w / -2 + (splitname[0] / 2 + 1);
                        } else {
                            // console.log(newData,"params.DoorPosOnEdit2222",splitname,splitname[0],typeof splitname[0],Number(mainPosArray[mainPos-1]) - Number(splitname[0]+1))
                            newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt(splitname[0]) + 2);
                        }
                        state.params.DoorPosOnEdit = { x: newData, y: 0, z: params.p_d / 2 };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = 0.5 * Math.PI * (1 + 1);
                        state.params.doorType = "Garage";
                        state.params.p_a_g_r_u_d = splitname[0] + "X" + splitname[1];
                    } else {
                        state.params.p_a_g_r_u_d = "Select";
                        var splitname = leftWallData.size.split("x");
                        if (mainPosArray[mainPos - 1] == undefined) {
                            newData = params.p_d / -2 + (splitname[0] / 12 / 2 + 1);
                        } else {
                            newData = Number(mainPosArray[mainPos - 1]) + Number(parseInt(splitname[0] / 12) + parseInt(splitname[0] / 12) + 2);
                        }
                        state.params.DoorPosOnEdit = { x: newData, y: 0, z: params.p_d / 2 };
                        mainPosArray[mainPos] = newData;

                        state.params.UpdatedDoorPosOnEdit = "";
                        state.params.DoorLocOnEdit = leftWallData.wall;
                        state.params.DoorRotOnEdit = 0.5 * Math.PI * (1 + 1);
                        params.doorType = "Walk";
                        params.p_d_c = splitname[0] + "X" + splitname[1];
                    }
                    mainPos++;
                }
            }
        }
        if (const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0) {
            let frontStorageWallComponent = const_var.defaultBuildingArr[state.defaultBuilding].default_doors.filter((data) => data.wall == "fubend");
            if (frontStorageWallComponent.length > 0) {
                for (let component of frontStorageWallComponent) {
                    let checkType = component.component == undefined ? component.type : component.component;
                    if (checkType == "garage_door") {
                        state.params.doorType = "Garage";
                        if (component.component == undefined) {
                            AddDoorComponentonWall(component.type, "standard_door", const_var.entry_wall_location_reverse["fubend"], component.size, "Garage", "standard_door", "Roll-Up", "");
                        } else {
                            AddDoorComponentonWall(component.component, component.type, const_var.entry_wall_location_reverse["fubend"], component.size, "Garage", component.type, component.category, "");
                        }
                    }
                }
            }

            if (params.isBreezeway || params.cB_addStorage_check_front) {
                const width = params.fourth_center_cost ? 8 : 10;
                const breezeWayFrameSize = width + "x" + params.p_h;
                // console.log(distanceOnLength,const_var.DistanceArr[params.p_b_t][params.p_r_s],breezeWayFrameSize ,"breezeWayFrameSize");
                AddDoorComponentonWall("garage_door_frameout", "standard_door", "c_b_l_w", breezeWayFrameSize, "Garage_Frameout", "standard_door", "Roll-Up", "", "", undefined, undefined, "isBreezewayFrame");
                AddDoorComponentonWall("garage_door_frameout", "standard_door", "c_b_r_w", breezeWayFrameSize, "Garage_Frameout", "standard_door", "Roll-Up", "", "", undefined, undefined, "isBreezewayFrame");
            }
        }
    }
};
const POSITION_TYPES = new Set(["window", "garage_door", "walkin", "window_frameout", "walkin_frameout", "garage_frameout"]);
export const shouldUseEntryPosition = (compType) => {
    return POSITION_TYPES.has(compType);
};
